import { Field, Item } from '@sitecore-jss/sitecore-jss-nextjs';

type GetEnumValueFn = <EnumType extends string>(
  enumItem: Item | undefined,
  defaultValue?: EnumType
) => typeof defaultValue extends undefined ? EnumType | '' : EnumType;

export const getEnumValue: GetEnumValueFn = <EnumType extends string>(
  enumItem: Item | undefined,
  defaultValue?: EnumType
): typeof defaultValue extends undefined ? EnumType | '' : EnumType =>
  ((enumItem?.fields?.Value as Field<string>)?.value || (defaultValue ?? '')) as EnumType;
